module.exports = __webpack_public_path__ + "static/media/ShgCategories.3f2a1e26.png";